import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { actions, getters } from "../model";
import { getEditTypeFile } from "../selectors";
import {
  BIZZABO_SETTINGS,
  EDIT_FILE_TYPE_FIELD_ID,
  EDIT_TYPE_FORM_ID,
  FILE_TYPES
} from "../constants";
import {
  BigFilledButton,
  BigOutlineButton,
  CloseIcon,
  Div,
  Text1,
  Text5
} from "components/Base";
import { Label } from "EventLight/Common";
import {
  Dropdown,
  Image,
  Input,
  WithFormInstanceProvider
} from "ui-kit/Form/View";
import MiniModalWrapper from "ui-kit/MiniModalWrapper";

import { useMobile } from "Portal/NewPortal/Shared/UseMobile";

const decorate = R.compose(
  WithFormInstanceProvider(R.always(EDIT_TYPE_FORM_ID)),
  connect(
    state => ({
      showModal: getters.showEditTypeModal(state),
      file: getEditTypeFile(state),
      settings: getters.settings(state),
      isSaveBtnDisabled: getters.isSaveBtnDisabled(state),
      viaPortal: getters.viaPortal(state)
    }),
    {
      hideModal: () => actions.setShowEditTypeModal(false),
      save: actions.saveUpdatedType
    }
  )
);

const WithModal = ({
  showModal,
  hideModal,
  save,
  file,
  settings = {},
  isSaveBtnDisabled = true,
  viaPortal = false
}) => {
  const isBizzaboEnabled = settings?.bizzabo_integration_enabled;
  const isMobile = useMobile();
  return (
    <MiniModalWrapper
      isPortal
      showHeader={false}
      showModal={showModal && file}
      hideModal={hideModal}
      height={isBizzaboEnabled ? "500px" : "inherit"}
      style={{
        ...(viaPortal && isMobile ? { width: "100%" } : {})
      }}
    >
      {file ? (
        <>
          <Div
            style={{
              flexShrink: 0
            }}
            display="row.space-between.center"
            bg="primary7"
            py={4.5}
            px={6}
            bb={1}
            bc="neutral2"
            brt={1}
          >
            <Text5 bold color="white">
              Edit File Type
            </Text5>
            <Div onClick={hideModal}>
              <CloseIcon color="white" sizeWFS={6} />
            </Div>
          </Div>
          <Div
            bg="white"
            p={5}
            style={{
              overflowY: "auto",
              height: !isBizzaboEnabled ? "250px" : "unset"
            }}
          >
            {isBizzaboEnabled && (
              <Div display="column" mb={5} width={1}>
                <Label>Display Name</Label>
                <Input
                  py={1}
                  fieldId={EDIT_FILE_TYPE_FIELD_ID.DISPLAY_NAME}
                  iniValue={R.pathOr(
                    "",
                    [BIZZABO_SETTINGS, EDIT_FILE_TYPE_FIELD_ID.DISPLAY_NAME],
                    file
                  )}
                  width="100%"
                  placeholder="Set display name..."
                />
              </Div>
            )}
            <Div display="column" mb={5} width={1}>
              <Label>Type</Label>
              <Dropdown
                fieldId={EDIT_FILE_TYPE_FIELD_ID.TYPE}
                iniValue={R.prop(EDIT_FILE_TYPE_FIELD_ID.TYPE, file)}
                width="100%"
                clearable={false}
                options={FILE_TYPES}
                placeholder="Select type..."
              />
            </Div>
            {isBizzaboEnabled && (
              <>
                <Div display="column" mb={5} width={1}>
                  <Label>Position</Label>
                  <Input
                    py={1}
                    fieldId={EDIT_FILE_TYPE_FIELD_ID.POSITION}
                    type="number"
                    iniValue={R.pathOr(
                      "",
                      [BIZZABO_SETTINGS, EDIT_FILE_TYPE_FIELD_ID.POSITION],
                      file
                    )}
                    width="100%"
                    placeholder="Set position..."
                  />
                </Div>
                <Div display="column" mb={5} width={1}>
                  <Label>Icon</Label>
                  <Text1 mb={1}>
                    For best use, upload a png file with a transparent
                    background. Recommended size is 230w X 160h
                  </Text1>
                  <Image
                    fieldId={EDIT_FILE_TYPE_FIELD_ID.ICON}
                    containerWidth="auto"
                    containerProps={{
                      display: "row.flex-start.flex-start",
                      flex: 1
                    }}
                    imageWidth={120}
                    imageHeight={120}
                    recommendedWidth={"230"}
                    recommendedHeight={"160"}
                    iniValue={
                      R.pathOr(
                        "",
                        [BIZZABO_SETTINGS, EDIT_FILE_TYPE_FIELD_ID.ICON],
                        file
                      )
                        ? [
                            {
                              url: R.pathOr(
                                "",
                                [
                                  BIZZABO_SETTINGS,
                                  EDIT_FILE_TYPE_FIELD_ID.ICON
                                ],
                                file
                              )
                            }
                          ]
                        : null
                    }
                  />
                </Div>
              </>
            )}
          </Div>
          <Div
            bg="white"
            width={1}
            p={6}
            style={{ borderTop: "1px solid #E7E6EA" }}
          >
            <BigOutlineButton mr={2} onClick={hideModal}>
              Cancel
            </BigOutlineButton>
            <BigFilledButton
              disabled={isBizzaboEnabled ? isSaveBtnDisabled : false}
              bg="altB5"
              color="white"
              onClick={save}
            >
              Save
            </BigFilledButton>
          </Div>
        </>
      ) : null}
    </MiniModalWrapper>
  );
};

export default decorate(WithModal);
